import { createContext } from 'react';

const descargasContext = createContext();

export default descargasContext;
